module.exports = [{
      plugin: require('/Users/adkantor/Documents/mkdecision/mkdecision-ui/node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/adkantor/Documents/mkdecision/mkdecision-ui/node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"google":{"families":["Open Sans:400,600,","Quicksand: 300,400,600"]}},
    }]
